<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">کاربر</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n16">
              <v-btn
                class="mt-3 mr-n16"
                fab
                dark
                small
                color="darkColor"
                @click="backToReport()"
                elevation="0"
              >
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field
                outlined
                rounded
                placeholder="جستجو..."
                append-icon="mdi-magnify"
                dense
                v-model="searchTitle"
                class="mt-3 mr-n16"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          hide-default-header
                          :headers="tableHeader"
                          :items="tableItems"
                          :items-per-page="tableItems.length"
                          height="67vh"
                          :search="searchTitle"
                          :hide-default-footer="true"
                          multi-sort
                          class="elevation-0 tt"
                        >
                          <template v-slot:header="props">
                            <app-group-table-header
                              :headers="props.props.headers"
                              @sort="props.on.sort"
                              @group="props.on.group"
                            />
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import AlertComponent from '@/components/AlertComponent.vue';
  import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import ShearedHelper from '@/Helpers/Shared.js';
  import CodeActivityReportDetailHelper from '@/Helpers/Report/Amar/CodeActivityReportDetailHelper.js';
  import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
  export default {
    name: 'amarCodeReportDetail',
    title: 'کاربر',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      AlertComponent,
      AppGroupTableHeader,
    },
    mixins: [ShearedMixin, CodeActivityReportDetailHelper, snackBar, ShearedHelper, PhoneMixin],
    created() {
      this.$root.$refs.AmarCodeReportDetail = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {
        let id = this.$route.params.id;
        this.getListOfUsersPhoneActivityReport(Number(id));
      },
    },
    computed: {},
  };
</script>
<style scoped lang="scss">
  .modal-header {
    border-bottom: 2px solid var(--modal-border-color);
    border-bottom-right-radius: 12px !important;
    border-bottom-left-radius: 12px !important ;
  }
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .modal-title-text {
    color: var(--dark-color);
    font-weight: 500;
    font-size: 16px;
  }
  .body-card {
    overflow-y: auto !important;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
  .calender-background {
    background: #79747e;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }
  >>> .tt tbody tr:nth-of-type(even) {
    background-color: var(--background-color) !important;
  }
</style>
